import { H5, RadioField, RadioFieldGroup, SlateViewer } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { IConsent } from "../../shared/types";
import { ConsentWrapper, Error } from "./CheckboxConsent";

interface Props {
	consent: IConsent;
	name: string;
}

const Actions = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacing(2)};
	align-items: center;
`;

export const RadioConsent: FC<Props> = ({ consent, name }) => {
	const { t } = useTranslation();
	const [, meta] = useField(name);

	return (
		<ConsentWrapper>
			{consent.headline && <H5>{consent.headline}</H5>}
			<SlateViewer content={consent.consent} />
			<Actions>
				<RadioFieldGroup name={name}>
					<RadioField value="true" label={t("Agree")} />
					<RadioField value="false" label={t("Disagree")} />
				</RadioFieldGroup>
			</Actions>
			{meta.touched && meta.error && <Error id={`${name}_error`}>{meta.error}</Error>}
		</ConsentWrapper>
	);
};
